// >>>>>>>>>>>>>>>>>>>>>>> Code to add >>>>>>>>
import React from "react";

export default function PrivacyPolicy() {
  return (
    <div style={{ padding: "2rem", maxWidth: "800px", margin: "0 auto" }}>
      <h1>Privacy Policy</h1>
      <p>Last updated: {new Date().getFullYear()}</p>

      <p>
        StockVisualize (“we”, “our”, “us”) operates stockvisualize.com and
        provides stock charts, metrics, and related tools. This page explains
        how we collect and use information.
      </p>

      <h2>Information We Collect</h2>
      <p>
        We do not collect personal data unless you voluntarily provide it (for
        example, through email contact). We use Google Analytics and Google
        AdSense, which may use cookies to deliver ads and measure performance.
      </p>

      <h2>Cookies & Advertising</h2>
      <p>
        Google may use cookies to personalise ads and analyse traffic. Users in
        the EEA, UK, and Switzerland will see a consent message managed by
        Google’s Consent Management Platform (CMP).
      </p>

      <h2>Data Usage</h2>
      <p>
        We use anonymous aggregated data to improve the site. We do not sell or
        share personal information with third parties.
      </p>

      <h2>Contact</h2>
      <p>
        If you have any questions, email us at:
        <br />
        <strong>stock.visualise@gmail.com</strong>
      </p>
    </div>
  );
}
// <<<<<<<<<<<<<<<<<<<<<<< Code to add <<<<<<<<<<<
